<template>
    <div>
        <template v-if="wholesaler === true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Shop </h1>
            </div>
            <div class="global-main">
                <form @submit.prevent="editShop">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Shop Name <em class="required">*</em></label>
                            <input v-model="form.shop" type="text" name="shop" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('shop') }">
                            <has-error :form="form" field="shop"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Shop Owner Name <em class="required">*</em></label>
                            <input v-model="form.name" type="text" name="name" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Phone <em class="required">*</em></label>
                            <input v-model="form.phone" type="text" name="phone" @keypress="isNumber($event)" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('phone') }">
                            <has-error :form="form" field="phone"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Address <em class="required">*</em></label>
                            <textarea v-model="form.address" name="address" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('address') }"></textarea>
                            <has-error :form="form" field="address"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/shops" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="wholesaler === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="wholesaler === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    shop : '',
                    name : '',
                    phone : '',
                    address : '',
                }),
                wholesaler: null,
            }
        },
        mounted() {
            this.$Progress.start();
            this.can('wholesaler').then(result => {
                this.wholesaler = result.wholesaler;
            }).then(result => {
                if(this.wholesaler == true){
					this.getEditShopData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            editShop() {
                this.$Progress.start();
                this.form.put('/api/updateShop')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Shop updated successfully');
                        this.$router.push('/shops');
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getEditShopData(){
                axios.get('/api/editShop/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.shop = res.data.shop;
                        this.form.name = res.data.name;
                        this.form.phone = res.data.phone;
                        this.form.address = res.data.address;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .then(res =>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            }
        }
    }

</script>
